import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=346d00d8&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=ts"
export * from "./TagsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d00d8",
  null
  
)

export default component.exports